import { EllipsisVertical } from "lucide-react";
import { Button } from "./button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";

interface UserActionsMenuProps {
  record: any;
  onUpdateStatus: (record: any) => void;
  onResetPassword: (record: any) => void;
  onLockUnlock: (record: any) => void;
}

export default function UserActionsMenu({
  record,
  onUpdateStatus,
  onResetPassword,
  onLockUnlock,
}: UserActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="p-0 h-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <EllipsisVertical className="h-5 w-5 text-gray-800 hover:text-gray-700" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" className="w-40 bg-white">
        <DropdownMenuItem
          className="cursor-pointer hover:bg-gray-100"
          onClick={(e) => {
            e.stopPropagation();
            onUpdateStatus(record);
          }}
        >
          Update Status
        </DropdownMenuItem>

        <DropdownMenuItem
          className="cursor-pointer hover:bg-gray-100"
          onClick={(e) => {
            e.stopPropagation();
            onResetPassword(record);
          }}
        >
          Reset Password
        </DropdownMenuItem>

        <DropdownMenuItem
          className="cursor-pointer hover:bg-gray-100 text-red-600"
          onClick={(e) => {
            e.stopPropagation();
            onLockUnlock(record);
          }}
        >
          {record.isLocked === 0 ? "Lock User" : "Unlock User"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
